import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 80px 0 120px;\n  background-color: #fdfdff;\n  text-align: center;\n\n  @media (max-width: 1200px) {\n    padding: 48px 20px 96px;\n  }\n  @media (max-width: 768px) {\n    padding: 48px 0;\n  }\n\n  .top {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (max-width: 410px) {\n      display: block;\n    }\n  }\n\n  .desc-box {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    margin-top: 58px;\n    padding: 28px 64px 48px;\n    background-color: #f0fafc;\n\n    @media (max-width: 1200px) {\n      padding-left: 16px;\n      padding-right: 16px;\n    }\n    @media (max-width: 768px) {\n      display: block;\n      padding: 8px 16px 36px;\n      margin-top: 24px;\n    }\n\n    .desc-item {\n      width: 275px;\n\n      @media (max-width: 1200px) {\n      }\n      @media (max-width: 768px) {\n        width: 100%;\n\n        &:not(:nth-of-type(1)) {\n          margin-top: 16px;\n        }\n      }\n\n      img {\n      }\n\n      p {\n        color: ",
        ";\n        line-height: 1.35;\n        margin: 0;\n      }\n\n      .title {\n        font-size: 24px;\n        font-weight: 900;\n        margin-top: 10px;\n\n        @media (max-width: 1200px) {\n          font-size: 22px;\n        }\n        @media (max-width: 768px) {\n          font-size: 20px;\n        }\n      }\n\n      .desc {\n        font-size: 20px;\n        font-weight: normal;\n        margin-top: 24px;\n\n        @media (max-width: 1200px) {\n          font-size: 18px;\n        }\n        @media (max-width: 1000px) {\n          br {\n            display: none;\n          }\n        }\n        @media (max-width: 768px) {\n          font-size: 16px;\n          margin-top: 16px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  font-size: 48px;\n  font-weight: bold;\n  color: ",
        ";\n  text-align: center;\n  line-height: 1.35;\n\n  @media (max-width: 1200px) {\n    font-size: 48px;\n  }\n  @media (max-width: 768px) {\n    font-size: 28px;\n  }\n  @media (max-width: 410px) {\n    font-size: 24px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  letter-spacing: -0.5px;\n  margin-top: 40px;\n  margin-right: 96px;\n\n  @media (max-width: 1200px) {\n    margin-right: 0;\n  }\n  @media (max-width: 768px) {\n    margin-top: 24px;\n\n    .ant-btn {\n      span {\n        font-size: 14px;\n        vertical-align: text-bottom;\n      }\n    }\n  }\n  @media (max-width: 410px) {\n    justify-content: end;\n\n    a {\n      display: block;\n      width: 100%;\n\n      .ant-btn {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  flex: 1;\n  height: 56px;\n  color: #ffffff;\n  font-weight: bold;\n  padding: 0 32px;\n  box-shadow: none;\n  border-radius: 2px;\n  border: 0;\n  background-color: ",
        ";\n\n  &.ant-btn-primary:not(:disabled):hover {\n    background-color: #113ac3;\n  }\n\n  span {\n    display: inline-block;\n    vertical-align: bottom;\n    font-size: 20px;\n    font-weight: bold;\n    color: #fff;\n  }\n\n  img {\n    display: inline-block;\n    vertical-align: text-bottom;\n    width: 24px;\n    height: 24px;\n    margin-right: 10px;\n  }\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    height: 48px;\n    padding: 0 24px;\n\n    img {\n      vertical-align: top;\n      width: 20px;\n      height: 20px;\n    }\n  }\n  @media (max-width: 410px) {\n    img {\n      vertical-align: baseline;\n      width: 16px;\n      height: 16px;\n      margin-right: 4px;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  margin-top: 96px;\n\n  video {\n    display: block;\n    max-width: 800px;\n    margin: 0 auto;\n    border: solid 1px #eaeae8;\n  }\n\n  @media (max-width: 1200px) {\n    padding: 0 56px;\n  }\n  @media (max-width: 768px) {\n    padding: 0;\n    margin-top: 48px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { VideoComponent } from "@/components/VideoComponent";
import { Button } from "antd";
import { Container } from "@/components";
import { themeGet } from "@styled-system/theme-get";
import Image from "next/image";
const ServiceVideoIntroWrapper = styled.div.withConfig({
    componentId: "sc-2725be20-0"
})(_templateObject(), themeGet("text.0", "#1B1B29"));
const TitleWrapper = styled.div.withConfig({
    componentId: "sc-2725be20-1"
})(_templateObject1(), themeGet("text.0", "#1B1B29"));
const ButtonWrapper = styled.div.withConfig({
    componentId: "sc-2725be20-2"
})(_templateObject2());
const CTAButton = styled(Button).withConfig({
    componentId: "sc-2725be20-3"
})(_templateObject3(), themeGet("primary.1", "#00bfc8"));
const VideoWrapper = styled.div.withConfig({
    componentId: "sc-2725be20-4"
})(_templateObject4());
export const IntroVideo = (param)=>{
    let {} = param;
    return /*#__PURE__*/ _jsx(ServiceVideoIntroWrapper, {
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "top",
                    children: /*#__PURE__*/ _jsxs(TitleWrapper, {
                        children: [
                            "좋은 교재, ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "더 잘 쓰이도록"
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "desc-box",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "desc-item",
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/static/assets/img-service-01.svg",
                                    alt: "아이콘",
                                    width: 120,
                                    height: 120
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "title",
                                    children: "당당하게 이용"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "desc",
                                    children: [
                                        "비싸고 복잡했던 라이선싱이 ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "플랫폼 거래로 간편해 집니다."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "desc-item",
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/static/assets/img-service-02.svg",
                                    alt: "아이콘",
                                    width: 120,
                                    height: 120
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "title",
                                    children: "편리하게 가공"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "desc",
                                    children: [
                                        "교재 중심의 현장 교육에 최적화한 ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "콘텐츠 이용툴을 제공합니다."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "desc-item",
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/static/assets/img-service-03.svg",
                                    alt: "아이콘",
                                    width: 120,
                                    height: 120
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "title",
                                    children: "활발하게 거래"
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "desc",
                                    children: [
                                        "현장 교육에서 생성되는 ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "다양한 교육콘텐츠를 수익화합니다."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(VideoWrapper, {
                    children: /*#__PURE__*/ _jsx(VideoComponent, {
                        videoSrc: "/static/videos/230105_solvookCI.mp4",
                        posterSrc: "/static/assets/video_poster.jpg"
                    })
                })
            ]
        })
    });
};
